import type {
  ClassifyAsContributionRequestBody,
  ClassifyAsExpenditureRequestBody,
  ExcludeFromReportRequest,
} from '../generated/dtos.gen';

export type ClassifyAsContributionFields = Pick<
  ClassifyAsContributionRequestBody,
  'bankTransactionConcurrencyVersion' | 'contactId' | 'contributionType'
> &
  Partial<ClassifyAsContributionRequestBody>;

export function classifyAsContributionRequest(fields: ClassifyAsContributionFields): ClassifyAsContributionRequestBody {
  return {
    electionDesignation: null,
    electionYear: null,
    paymentMethod: null,
    notes: null,
    inKindFairMarketValueBasis: null,
    inKindNature: null,
    transferQualification: null,
    ...fields,
  };
}

export type ClassifyAsExpenditureFields = Pick<
  ClassifyAsExpenditureRequestBody,
  'bankTransactionConcurrencyVersion' | 'subCategory'
> &
  Partial<ClassifyAsExpenditureRequestBody>;

export function classifyAsExpenditureRequest(fields: ClassifyAsExpenditureFields): ClassifyAsExpenditureRequestBody {
  return {
    contactId: null,
    category: null,
    purpose: null,
    paymentProcessorId: null,
    refundOfContributionId: null,
    capturedReceiptId: null,
    debtId: null,
    loanId: null,
    mdExpenseCategory: null,
    mdExpensePurpose: null,
    hint: null,
    ...fields,
  };
}

export type ExcludeFromReportFields = Pick<ExcludeFromReportRequest, 'concurrencyVersion'> &
  Partial<ExcludeFromReportRequest>;

export function excludeFromReportRequest(fields: ExcludeFromReportFields): ExcludeFromReportRequest {
  return { ...fields, note: fields.note ?? null };
}
